import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import {
  Alert as ChakraUIAlert,
  AlertProps as ChakraUIAlertProps,
  AlertTitle,
  AlertIcon,
  AlertDescription,
  StyleProps
} from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

const getBaseStyle = (props: ChakraUIAlertProps) => {
  const { status, variant = "solid" } = props;

  const getBase = (statusKey: string) =>
    status === statusKey &&
    variant === "solid" && {
      container: {
        background: `feedback.${statusKey}`
      }
    };

  const successBase = getBase("success");
  const warningBase = getBase("warning");
  const errorBase = getBase("error");
  const infoBase = getBase("info");

  return {
    ...successBase,
    ...warningBase,
    ...errorBase,
    ...infoBase
  };
};

const baseStyle = definePartsStyle(getBaseStyle);

const AlertComponentStyle = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    variant: "solid"
  }
});

export interface AlertProps
  extends Pick<
      ChakraUIAlertProps,
      | "id"
      | "size"
      | "status"
      | "variant"
      | "children"
      | "onClick"
      | "className"
      | "alignItems"
      | "justifyContent"
    >,
    StyleProps {}

export function Alert(props: AlertProps) {
  return <ChakraUIAlert {...props} borderRadius="md" />;
}

export { AlertIcon, AlertTitle, AlertDescription, AlertComponentStyle };
